// Jobs — the unit of work — together with their publications.
//
// Pure data — no imports, ever. errors.js reads he.leads.needContact at module scope,
// so a part reaching back for it would hand that read a half-built object. See he.js.
const jobs = {
  jobs: {
    // The screen lists one-off work only. `newJob` / `editJob` stay the generic wording
    // because the same modal opens from the retainer screen to add a topic; the one-off
    // screen passes the standalone wording below instead.
    title: 'פרויקטים חד־פעמיים',
    newStandalone: 'פרויקט חדש',
    newJob: 'עבודה חדשה',
    editJob: 'עריכת עבודה',
    jobTitle: 'שם העבודה',
    client: 'לקוח',
    stream: 'סוג הכנסה',
    issuer: 'מפיק/ה חשבונית',
    // The issuer now works on two levels: the unit carries a DEFAULT, and each invoice
    // records who actually issued it. The labels have to say which one is on screen,
    // or a partner changing the default will reasonably expect it to rewrite history.
    defaultIssuer: 'מפיק/ה חשבונית (ברירת מחדל)',
    // The same thing as a table column, where the long form would crowd the header.
    defaultIssuerShort: 'מפיק/ה (ברירת מחדל)',
    // ברירת המחדל שעוד לא נבחרה (074). מאז 068 המפיק/ה אינו/ה קובע/ת כסף — כל תשלום
    // אומר מי גבה אותו.
    issuerUndecided: 'טרם הוחלט',
    invoiceIssuerHint: 'מי הפיק/ה את החשבונית הזו בפועל. ההכנסה שנגבתה נזקפת לעסק של מי שהפיק/ה אותה.',
    status: 'סטטוס',

    // תאריכי העבודה (062) — מתי העבודה רצה. טקסט בלבד: אין תזכורת, אין התראה ואין
    // חסימה, ושום סכום לא מושפע מהם. ההתראות נשארות ברמת הריטיינר, שהוא היחיד שמחייב
    // חודש־בחודשו — עבודה שהייתה מתריעה בעצמה הייתה מכפילה את אותה התראה על אותה
    // התקשרות.
    workTerm: 'תקופת העבודה',
    workStartDate: 'תחילת העבודה',
    workEndDate: 'סיום העבודה',
    workTermNone: 'לא הוגדרו תאריכים',
    // כשרק צד אחד מהתאריכים מולא. "01/02/2026 – —" נקרא כמו תקלה; זה נקרא כמו עובדה.
    workTermFromPrefix: 'החל מ־',
    workTermUntilPrefix: 'עד',
    // הסימון העדין: העבודה חורגת מתאריכי ההתקשרות שמעליה. עבודה שנמשכת מעבר לריטיינר
    // היא דבר לגיטימי ושכיח — לכן מסמנים ולא מונעים, וההודעה אומרת את זה במפורש.
    //
    // הסימון אומר לאיזה כיוון החריגה, ולא רק שיש חריגה. "חורג מתקופת ההתקשרות" נקרא
    // כ"נמשך אחרי הסיום", ולכן עבודה שהתחילה ארבעה ימים לפני ההתקשרות דווחה במילים
    // ששלחו את הקורא לבדוק את תאריך הסיום. שלוש מחרוזות, אחת לכל כיוון.
    //
    // כיוון, לא שדה: עבודה שמתחילה אחרי שההתקשרות כבר הסתיימה חורגת דרך תאריך ההתחלה
    // שלה, ותווית שנקראת מהשדה הייתה אומרת עליה "לפני ההתקשרות" — הפוך בדיוק.
    beforeRetainerTerm: 'לפני תחילת ההתקשרות',
    afterRetainerTerm: 'אחרי סיום ההתקשרות',
    beyondRetainerTerm: 'חורג משני צידי ההתקשרות',
    // ההסבר מראה את תאריכי ההתקשרות עצמם — טענה שהעבודה חורגת, בלי התאריכים שלפיהם
    // נמדדה, מחייבת את הקורא ללכת ולבדוק במסך אחר.
    beyondRetainerTermHint: (from, to) => `תקופת ההתקשרות: ${from} – ${to}. סימון בלבד — לא חוסם רישום חשבונית, הוצאה או תשלום.`,
    // כשלריטיינר אין תאריך באותו צד.
    workTermOpen: 'ללא תאריך',

    // סיום עבודה — הפעולה שמוציאה עבודה מהרשימה הפעילה, ולא נוגעת בשום סכום.
    // שני מצבי סיום שנבדלים רק במה שהם *אומרים*, בדיוק כמו בריטיינר.
    closeJob: 'סיום עבודה',
    closeJobAction: 'סיום העבודה',
    reopenJob: 'החזרה לפעיל',
    closeJobChoice: 'מה קרה לעבודה?',
    closeJobCompleted: 'הושלמה — העבודה נעשתה',
    closeJobCancelled: 'בוטלה — העבודה לא תתבצע',
    // The list's view toggle. עבודה is feminine, so these are not the retainer's words.
    showOpenJobs: 'פעילות',
    showDoneJobs: 'שהסתיימו',
    // Empty states: one short line each.
    emptyOpen: 'אין פרויקטים חד־פעמיים',
    emptyDone: 'אין פרויקטים שהסתיימו',
    emptyExpenses: 'אין הוצאות',
    // רישום הכנסה על עבודה — מקרה התיווך. העבודה מתחת לריטיינר בדרך כלל לא מכניסה
    // בעצמה, אבל קנייה ומכירה חוזרת (צלם שעלה 400 וחויב ב-1,000) היא הכנסה של העבודה.
    recordJobIncome: 'רישום הכנסה לעבודה',
    recordJobIncomeAction: 'רישום ההכנסה',
    // The button on the job screen, worded like every other add button on it —
    // "רישום הכנסה" beside "הוספת הוצאה". It stands alone: no line explains adding an
    // expense, and nothing explains this either.
    recordIncome: 'רישום הכנסה',
    // The dialog carries no explanation of what the save moves between the retainer's
    // profit and the job's — it is four fields and two buttons, like recording an
    // expense. The figures it changes are shown on the screens that report them.
    jobIncomeConvertedNotBilled:
      'העבודה כבר הוגדרה כמחייבת בעצמה, אבל החשבונית לא נרשמה. אפשר לנסות שוב — השלב הראשון '
      + 'לא יבוצע פעמיים.',
    noIncomeYet: 'לעבודה אין הכנסה משלה',

    // A job either carries its own income or is a topic inside a retainer that bills
    // for it. The distinction is explicit on the server (income_source) and shown here
    // rather than left to be guessed from whether a retainer happens to be attached.
    incomeSource: 'מקור ההכנסה',
    incomeOwn: 'הכנסה עצמאית',
    // WHERE THE INCOME IS, not where the job sits. The old label — "נושא בתוך ריטיינר" —
    // conflated the two, and they are genuinely independent: a job under a retainer may
    // still bill its own brokerage margin, in which case the right answer here is
    // "הכנסה עצמאית" even though it does sit inside a retainer. Naming the income makes
    // the option say exactly what the field decides, and it is what keeps this readable
    // now that "עבודה" no longer distinguishes anything on its own.
    incomeRetainer: 'ההכנסה בריטיינר',
    // The same choice, named by the engagement the job sits under (067).
    incomeInRetainer: 'ההכנסה במסגרת הריטיינר',
    incomeInProject: 'ההכנסה בפרויקט',
    retainer: 'ריטיינר',
    noRetainer: 'ללא ריטיינר (עבודה עצמאית)',
    // The picker's label: a job sits under a retainer or a one-off project (067).
    engagement: 'ריטיינר / פרויקט',
    pickRetainerForTopic: 'יש לבחור את הריטיינר שהעבודה שייכת אליו — לעבודה אין הכנסה משלה, והעלויות שלה נזקפות לריטיינר.',
    noRetainerForClient: 'ללקוח זה עדיין אין ריטיינר. צרו ריטיינר במסך הריטיינרים, או בחרו "הכנסה עצמאית".',
    // The badge on a job screen for a job with no income of its own. Renaming it to
    // "עבודה" would have made it say nothing at all — every row on every screen is one.
    // What the badge was ALWAYS for is the money fact behind the word: this one has no
    // P&L, so the screen below shows costs and no profit. So it now states that fact
    // directly, and pairs with retainers.ownIncome as the two answers to the same question.
    topicBadge: 'ההכנסה בריטיינר',
    cost: 'עלויות',
    // No note accompanies the cost tile on a job with no income of its own. The tile is
    // labelled עלויות, the badge above already says ההכנסה בריטיינר, and the button beside
    // it records income — three things that each say what they are. The paragraph that
    // used to sit here (topicNoProfit) explained all three again.
    viewRetainer: 'מעבר לריטיינר',
    recurring: 'ריטיינר חודשי',
    recurringAmount: 'סכום חודשי (ללא מע"מ)',
    recurringShort: 'חודשי',
    recurringMonthly: 'עבודה חוזרת, סכום חודשי',
    retainerMonths: 'מספר חודשים',
    issuedProgress: 'חשבוניות שהופקו',
    retainerComplete: 'הריטיינר הושלם',
    // The retainer's whole term as money, mirroring the one-off job's agreed value.
    contractValue: 'שווי הריטיינר הכולל',
    agreedAmount: 'שווי מוסכם עם הלקוח (ללא מע"מ)',
    agreedValue: 'שווי מוסכם',
    remainingToInvoice: 'נותר לחיוב',
    // Deleting a job is permanent and takes everything hanging off it. The dialog frame
    // and the item labels are shared with the retainer delete and live in `common`;
    // only what is specific to a JOB is here.
    deleteJob: 'מחיקת עבודה',
    // A topic's blast radius is the question everyone asks first, so it is answered
    // before it is asked.
    deleteTopicScope: 'תימחק העבודה הזו בלבד. הריטיינר ושאר העבודות שתחתיו לא ייפגעו.',
    deleteBalanceNote: 'המאזן בין השותפים יתעדכן מיד.',
    editExpense: 'עריכת הוצאה',
    cancelInvoice: 'ביטול חשבונית',
    showCancelled: 'הצג חשבוניות שבוטלו',
    hideCancelled: 'הסתר חשבוניות שבוטלו',
    revenue: 'הכנסה',
    expenses: 'הוצאות',
    profit: 'רווח נקי',
    // The same three figures on a job that sits under a retainer and bills its own charge.
    // To the owner that money is a cost passed on to the client, not income, so the tiles
    // name it that way. Labels only: the figures are the job's revenue, cost and profit,
    // unchanged. A standalone brokerage job keeps the plain three labels above.
    // Everyday words, not accounting ones. "ביקשנו" and never "קיבלנו": the figure is what
    // was invoiced, not what came in. "עלה לנו" and never "שילמנו": the figure counts
    // costs committed but not yet paid.
    passThroughRevenue: 'כמה ביקשנו מהלקוח',
    passThroughCost: 'כמה זה עלה לנו',
    passThroughProfit: 'מה נשאר לנו',
    shares: 'חלוקת רווח',
    invoices: 'חשבוניות',
    month: 'חודש',
    expensesList: 'הוצאות',
    addExpense: 'הוספת הוצאה',
    // Invoices are issued in the accounting software; here they are only recorded.
    recordInvoice: 'רישום חשבונית',
    editInvoice: 'עריכת חשבונית',
    retainerMonth: 'חודש הריטיינר',
    invoiceAmount: 'סכום',
    issueDate: 'תאריך החשבונית',
    // Column header in the invoice list — short, because the table is already invoices.
    issuerShort: 'מפיק/ה',
    paid: 'שולם',
    balance: 'יתרה',
    dueDate: 'תאריך יעד',
    category: 'קטגוריה',
    amount: 'כמה זה עלה לנו',
    assessedValue: 'כמה זה שווה (לדיווח בלבד)',
    payer: 'מי שילם',
    vendor: 'ספק',
    description: 'תיאור',
    isGoods: 'תשלום בשווה כסף',
    recordPayment: 'רישום תשלום',
    // The income card on the job screen — the mirror of the expense card, so its
    // labels are the expense labels' opposite numbers, column for column:
    //   קטגוריה / תיאור  the same two, from income_categories instead of expense ones
    //   סכום            what was charged, against עלות בפועל
    //   נגבה            what came in, against שווי מוערך (the second money column)
    //   הופק ע"י        who billed it, against שולם ע"י — whose business the money is in
    incomeList: 'הכנסות',
    incomeAmount: 'סכום',
    collected: 'נגבה',
    issuedBy: 'הופק ע"י',
  },
  jobStatus: {
    open: 'פתוח',
    in_progress: 'בתהליך',
    completed: 'הושלם',
    cancelled: 'בוטל',
  },
  publications: {
    title: 'פרסומים',
    emptyList: 'אין פרסומים',
    add: 'הוספת פרסום',
    edit: 'עריכת פרסום',
    name: 'כותרת',
    namePlaceholder: 'למשל: ראיון עם המנכ"ל',
    // A piece runs in several outlets at once — one release goes to ten papers.
    outlets: 'איפה פורסם',
    outletsHint: 'בחרו את כל העיתונים והאתרים שבהם הפריט התפרסם.',
    outletSearch: 'חיפוש עיתון...',
    outletAdd: 'הוספת עיתון חדש',
    outletAddPrompt: 'שם העיתון או האתר',
    outletRanOn: 'תאריך בעיתון זה',
    outletRanOnHint: 'רק אם התפרסם שם בתאריך אחר.',
    outletUrl: 'קישור',
    outletRemove: 'הסרת העיתון מהפרסום',
    // Removing an outlet would strand its clipping, so it is refused by name.
    outletHasClipping: 'יש קטע עיתונות מצורף לעיתון הזה. יש להסיר אותו קודם',
    noOutlets: 'לא נבחרו עיתונים',
    // Every file is the screenshot of how the piece appeared in one paper.
    clippings: 'קטעי עיתונות',
    clippingAdd: 'צירוף קטע',
    clippingAssign: 'לאיזה עיתון?',
    clippingsBulk: 'בחירת קטעים לכמה עיתונים',
    clippingsUpload: 'העלאת הקטעים',
    date: 'תאריך פרסום',
    notes: 'הערות',
    job: 'עבודה',
    files: 'קבצים',
    noFiles: 'לא צורפו קטעי עיתונות',
    addFile: 'צירוף קובץ',
    uploading: 'מעלה...',
    view: 'צפייה',
    download: 'הורדה',
    removeFile: 'הסרת קובץ',
    // Tooltip on the row's delete: names the whole publication so it can't be
    // mistaken for removing one screenshot.
    deletePublication: 'מחיקת הפרסום כולו',
    // A publication is created first, then files are attached to it.
    saveFirst: 'שמרו את הפרסום כדי לצרף קבצים.',
    confirmDelete: 'למחוק את הפרסום ואת כל הקבצים שלו?',
  },
};

export default jobs;
